import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TranslationPage from './pages/TranslationPage';
import UserGuide from './pages/UserGuide';
import NewsletterReview from './pages/NewsletterReview';
import NewsletterCompare from './pages/NewsletterCompare';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/translation" element={<TranslationPage />} />
                <Route path="/userguide" element={<UserGuide />} />
                <Route path="/newsletter-review" element={<NewsletterReview />} />
                <Route path="/newsletter-compare" element={<NewsletterCompare />} />
            </Routes>
        </Router>
    );
}

export default App;
